<template>
    <!-- Mesmo resumo da listagem de canais (ChannelListView), em formato de bloco -->
    <button type="button" class="ict" :class="{'is-open': open, 'is-compact': compact}"
        :aria-expanded="open ? 'true' : 'false'" @click="$emit('toggle')">
        <fa icon="chevron-right" class="ict-chevron" />

        <span class="ict-stack" aria-hidden="true">
            <ChannelLogoCmp v-for="c in brandStack" :key="`stack-${c.enumChannel}`"
                :channel="c" :size="compact ? 16 : 20" :show-name="false" />
            <span v-if="brandOverflow" class="ict-stack-more">+{{brandOverflow}}</span>
        </span>

        <span class="ict-label">{{label}}</span>
        <span class="ict-action">{{open ? 'Ocultar' : 'Mostrar'}}</span>
    </button>
</template>

<script>
import ChannelLogoCmp from '@/channel/components/ChannelLogoCmp.vue'

const STACK_LIMIT = 5

export default {
    name: 'InactiveChannelsToggleCmp',
    components: {
        ChannelLogoCmp,
    },
    props: {
        // Canais (ChannelModel) que estão no grupo
        channels: {
            type: Array,
            required: true,
        },
        open: {
            type: Boolean,
            default: false,
        },
        // Versão baixa, para ficar dentro de tabela
        compact: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        label() {
            const count = this.channels.length

            return count === 1 ? '1 canal inativo' : `${count} canais inativos`
        },
        // Uma marca por canal: duas contas da Shopee mostram um ícone só
        brands() {
            const seen = new Set()

            return this.channels.filter((c) => {
                if (seen.has(c.enumChannel)) {
                    return false
                }

                seen.add(c.enumChannel)
                return true
            })
        },
        brandStack() {
            return this.brands.slice(0, STACK_LIMIT)
        },
        brandOverflow() {
            return Math.max(0, this.brands.length - STACK_LIMIT)
        },
    },
}
</script>

<style lang="scss" scoped>
.ict {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 12px 16px;
    border: 1px dashed var(--border-strong);
    border-radius: 14px;
    color: var(--text-muted);
    background: var(--surface-2);
    font-size: 14px;
    text-align: left;
    cursor: pointer;
    transition: background-color .15s, border-color .15s;

    &:hover {
        border-color: var(--tint-brand-border);
        background: color-mix(in srgb, var(--brand) 5%, var(--surface-2));

        .ict-action {
            text-decoration: underline;
        }
    }

    &:focus {
        outline: 0;
    }

    &:focus-visible {
        box-shadow: 0 0 0 3px var(--focus-ring);
    }

    &.is-open {
        border-style: solid;
    }

    &.is-compact {
        gap: 10px;
        padding: 8px 12px;
        border: 0;
        border-radius: 0;
        font-size: 13px;
    }
}

.ict-chevron {
    width: 10px;
    color: var(--text-faint);
    font-size: .75em;
    transition: transform .18s ease-in-out;

    // Preso ao próprio botão: um ancestral com .is-open (ex.: variação aberta) não pode girar a seta
    .ict.is-open & {
        transform: rotate(90deg);
    }
}

// Pilha de marcas: dá para saber quais canais estão ali sem abrir o grupo
.ict-stack {
    display: inline-flex;
    align-items: center;

    .channel-logo {
        border-radius: 5px;
        box-shadow: 0 0 0 2px var(--surface-2);
        filter: grayscale(.5);
        opacity: .9;

        & + .channel-logo {
            margin-left: -4px;
        }
    }
}

.ict-stack-more {
    margin-left: 6px;
    color: var(--text-faint);
    font-size: .8em;
    font-weight: 600;
}

.ict-label {
    font-weight: 600;
}

.ict-action {
    margin-left: auto;
    color: var(--brand);
    font-size: .9em;
    font-weight: 700;
}
</style>
